module.exports = __webpack_public_path__ + "04dc6f64b5786db861d414ea30668285.png";